// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1_vGD","cls2":"AuthorHeader-cls2_ZfC AuthorHeader-cls1_vGD"};